import classNames from "classnames";
import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { SEARCH_EXCLUDE_CLASSNAME } from "../SearchIndex";
import replaceTags from "../../helpers/replaceTags";
import { ServiceTile } from "../Tile";

interface Props {
  title: string;
  related: any[];
}

export const RelatedServices = ({ title, related }: Props) => {
  const {
    enriseSettings: { plural, single },
  } = useStaticQuery(query);

  if (!related || related?.length === 0) {
    return null;
  }

  return (
    <section
      className={classNames(
        SEARCH_EXCLUDE_CLASSNAME,
        "relative z-10 w-full bg-brand-light"
      )}
    >
      <div className="container grid grid-cols-1 gap-6 py-12 md:grid-cols-2 lg:grid-cols-3">
        <p className="h2 hidden text-center md:col-span-2 md:block lg:col-span-3">
          {replaceTags(related?.length > 1 ? plural : single, {
            title,
          })}
        </p>
        <p className="h2 text-center md:col-span-2 md:hidden lg:col-span-3">
          {replaceTags(single, { title })}
        </p>
        {related?.map((service, i) => (
          <ServiceTile
            key={i}
            service={service}
            className={classNames({
              "hidden md:flex": i === 1,
              "hidden lg:flex": i === 2,
            })}
          />
        ))}
      </div>
    </section>
  );
};

const query = graphql`
  {
    enriseSettings {
      plural: relatedServicesTitle
      single: relatedServiceTitle
    }
  }
`;
